import React from 'react';
import {FieldsRendererProps} from '../FieldsRenderer';
import {Grid} from '@mui/material';
import {Stack} from '@mui/material';
import {AppControlledTimePicker} from 'components/form';

interface RenderTimePickerProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderTimePicker: React.FC<RenderTimePickerProps> = ({control, field, baseFieldName, gridSize}) => {
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledTimePicker
                    label={field.title}
                    control={control}
                    views={['hours', 'minutes']}
                    format="hh:mm"
                    defaultValue={new Date()}
                    required={field.isRequired}
                    name={`${baseFieldName}.value`}
                />
            </Stack>
        </Grid>
    );
};

export default RenderTimePicker;
